import BotsOverview from "../Campaigns/BotsOverview";
import { CampaignContext } from "../../contexts/CampaignContext";
import { useContext, useState, useEffect } from "react";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import HMSTimeField from "../../components/forms/HMSTimeField/HMSTimeField";
import CirclePerc from "../../components/CirclePerc/CirclePerc";
import FeatureControls from "../../components/FeatureControls/FeatureControls";
import { IconJsxer } from "../../helpers/IconHelper";
import LottieIcon from "../../components/common/LottieIcon";
import StreamTranscriptItem from "../../components/Streams/StreamTranscriptItem";
import {CHANNEL_COLOURS, CalculateEngagementTime, GetPeakViewerTime, CalculateHashtagChartData, CalculateBotsTriggered, UserInteractionMessageChartData, ViewerCountChartData, ChattersChartData, CalculateAvgMsgPerUser, CalculateAvgInteractionPerUser, InteractionChartData, CalculateTopChatters, CalculateTopInteractionUsers, FEATURE_TIMELINE_DISPLAY, GetTopUsers, GetFeaturesRunCount, GetDisruptorsRunCount } from "../../helpers/AnalyticsFunctions";
import { assets } from "../../assets/assets";
import Toggle from "../../components/forms/Toggle/Toggle";
import { LineChart, AreaChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar, ReferenceLine } from 'recharts';
import { convertMSToHMS, getShortDateTimeString, getShortTimeString } from "../../helpers/Dates";
import { getIconCategoryClass, getIconCategoryColor } from "../../components/common/iconCategory";

import { getLiveStreamAnalyticData, getSessionAnaliticsData } from "../../api/routes";
import FormDropDown from "../../components/forms/DropDownList/FormDropDown";
import DropDownList from "../../components/forms/DropDownList/DropDownList";


const COLORS = ['#8C6CFF', '#79C8F2'];
const COLORS1 = ['#8C6CFF', '#FFD581'];
const MS_TIMES = {
    SECS_10: 10000,
    SECS_30: 30000,
    MINS_1: 60000,
    MINS_5: 300000,
    MINS_10: 600000,
    MINS_15: 900000,
    MINS_30: 1800000,
    HOURS_1: 3600000
}

const CHART_AXIS_STYLE = {
    stroke: 'var(--body-copy-color-light, #8a8ea6)',
    tick: { fill: 'var(--body-copy-color-light, #8a8ea6)', fontSize: 12 },
    axisLine: { stroke: 'var(--mid-grey-2)' },
    tickLine: { stroke: 'var(--mid-grey-2)' },
};

const CHART_TOOLTIP_PROPS = {
    contentStyle: {
        backgroundColor: 'var(--customisation-group-panel-bg)',
        border: '1px solid var(--mid-grey-2)',
        borderRadius: '12px',
        color: 'var(--body-copy-color, #f5f7ff)',
    },
    itemStyle: { color: 'var(--body-copy-color, #f5f7ff)' },
    labelStyle: { color: 'var(--body-copy-color, #f5f7ff)' },
};

const PIE_SLICE_STROKE = 'var(--customisation-group-panel-bg)';
const PIE_SLICE_STROKE_WIDTH = 3;
const MESSAGE_CHART_FILL = '#79C8F2';
const MESSAGE_CHART_STROKE = '#4C9ECE';
const INTERACTION_CHART_FILL = '#FFD581';
const INTERACTION_CHART_STROKE = '#D9AF57';
const USERS_CHART_FILL = '#8C6CFF';
const USERS_CHART_STROKE = '#6D4CF0';



const TabAnalytics = (props) => {
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);
    const [chartUsername, setChartUsername] = useState('');

    const [prevChannel, setPrevChannel] = useState('')
    const [topUserChart, setTopUserChart] = useState('messages');
    const [messagePerTime, setMessagePerTime] = useState(MS_TIMES.MINS_1);
    const [selectedMessagePerTime, setSelectedMessagePerTime] = useState(null);
    const [selectedTopUsersType, setSelectedTopUsersType] = useState(null);
    const [selectedTopUsersTime, setSelectedTopUsersTime] = useState(null);
    const [topChattersStartTime, setTopChattersStartTime] = useState(props._analyticsData.featureStartTime)
    const [chattersBarTimeVariation, setChattersBarTimeVariation] = useState(MS_TIMES.MINS_5)
    const [chattersStartTimeOffset, setChattersStartTimeOffset] = useState(-1);
    const [pollingLiveAnlyticsData, setPollingLiveAnlyticsData] = useState(0);

    const [interactionUsername, setInteractionUsername] = useState('');
    const [topInteractionStartTime, setTopInteractionStartTime] = useState(props._analyticsData.featureStartTime)
    const [interactionBarTimeVariation, setInteractionBarTimeVariation] = useState(MS_TIMES.MINS_5)
    const [interactionStartTimeOffset, setInteractionStartTimeOffset] = useState(-1)
    // const [currentDisruptor, setCurrentDisruptor] = useState(null);
    // const [previewMode, setPreviewMode] = useState(false);
    const streamTargetTime = props._streamData.endTime - props._streamData.startTime;
    const targetTimeHms = convertMSToHMS(streamTargetTime, true);
    const liveTimeObj = props._streamLiveTime || { hoursStr: '00', minutesStr: '00', secondsStr: '00', rawHours: 0, rawMinutes: 0, rawSeconds: 0 };
    const liveTimeSecs = liveTimeObj.rawHours * 3600 + liveTimeObj.rawMinutes * 60 + liveTimeObj.rawSeconds;
    const liveTimePerc = liveTimeSecs / (streamTargetTime / 1000) * 100;
    const campaignFeatures = campaignContext?.campaignData?.features || [];

    const getCampaignFeatureForTimelineEntry = (entry) => {
        if (!entry) return null;

        const entryFeatureId = entry.featureID?.toString?.() || entry.featureID;
        if (entryFeatureId) {
            const matchedById = campaignFeatures.find((feature) => {
                const featureId = feature?._id?.toString?.() || feature?._id;
                return featureId === entryFeatureId;
            });
            if (matchedById) return matchedById;
        }

        return campaignFeatures.find((feature) => feature?.varKey === entry.varKey) || null;
    };

    const getTimelineDisplay = (entry) => {
        let displayData = FEATURE_TIMELINE_DISPLAY.feature;
        if (FEATURE_TIMELINE_DISPLAY[entry.featureType]) {
            displayData = FEATURE_TIMELINE_DISPLAY[entry.featureType];
        }
        if (FEATURE_TIMELINE_DISPLAY[entry.varKey]) {
            displayData = FEATURE_TIMELINE_DISPLAY[entry.varKey];
        }
        if (FEATURE_TIMELINE_DISPLAY[entry.colourCategory]) {
            displayData = FEATURE_TIMELINE_DISPLAY[entry.colourCategory];
        }
        return displayData;
    };

    const selectDisruptor = (d) => {
        console.log('Select distruptor: ', d);
        props._setPreviewMode(false);
        props._setCurrentDisruptor(d);
        //Test
    }

    
    const updateChannelFilterHandler = async (e, id, item) => {

        console.log(item, id)
        setChannelFilter(item);
    }
    const [channelFilter, setChannelFilter] = useState(null);
    const GetSessionDropdown = (props) => {
    
        let dropDownItems = 
            [
                {id:'all', label:'All'}
            ];
    
        if(props._analyticsData.channels &&  props._analyticsData.channels.length > 1)
        {
            for(let i=0; i<props._analyticsData.channels.length; i++)
            {
                let channelObj = props._analyticsData.channels[i];
                if(channelObj.channel)
                {
                    dropDownItems.push({id:channelObj.channel, label:channelObj.channel.toUpperCase() })
                }
            }
        }
        
    
    console.log(dropDownItems)
    
        return(
            <DropDownList 
            id="assignedTo" 
            selectFunc={updateChannelFilterHandler}
            currentIndex={channelFilter ? channelFilter.index : 0}
            icon="oneUser"
            items={
                dropDownItems
            }
            className="filter"
        >
    
        </DropDownList>
        )
    
    
    }

    const getFullAnalyticData = () => {
        if (props._sessionID) {
            // We need historical session analytics!
            console.log('GAD',  props._analyticsData )
            axios
                .get(getSessionAnaliticsData, {
                    params: { sessionID: props._analyticsData, analyticsObj:props._analyticsObj },
                    withCredentials: true
                })
                .then(function (response) {
                    console.log(response.data.analyticsData)
                    props._updateAnalyticsFunc(response.data.analyticsData);
                })
                .catch(function (error) {
                    toast.error('Error - ' + error);
                });
        } else {
            if (props._connected) {
                axios
                    .get(getLiveStreamAnalyticData, {
                        params: { streamID: props._streamID },
                        withCredentials: true
                    })
                    .then(function (response) {
                        console.log(response.data.analyticsData)
                        props._updateAnalyticsFunc(response.data.analyticsData);
                    })
                    .catch(function (error) {
                        toast.error('Error - ' + error);
                    });
            }
        }
        setPollingLiveAnlyticsData(0);
    }

    //Messages Chart Functions
    const changeTopChattersStartTime = (timeDiff, barTimeVariation) => {
        setChartUsername('');
        setChattersStartTimeOffset(timeDiff)
        setChattersBarTimeVariation(barTimeVariation);
    }

    const getFeatureEndTime = () => {
        if(!props._sessionID) return props._analyticsData.featureEndTime;
        return props._analyticsData.featureStartTime + props._analyticsData.featureRunTime;
    }
    const getLiveEndTime = () => {
        if(!props._sessionID) return Date.now();
        return props._analyticsData.featureStartTime + props._analyticsData.featureRunTime;
    }
    const updateTopChattersStartTime = () => {
        if (chattersStartTimeOffset == -1) setTopChattersStartTime(props._analyticsData.featureStartTime)
        else {
            var roundedStartTime = Math.floor((Date.now() - props._analyticsData.featureStartTime) / chattersBarTimeVariation) * chattersBarTimeVariation + props._analyticsData.featureStartTime;
            let newTime = roundedStartTime - chattersStartTimeOffset;
            if (newTime < props._analyticsData.featureStartTime) newTime = props._analyticsData.featureStartTime;
            setTopChattersStartTime(newTime);
        }
    }

    const historicalTimeBar =() =>{
        let timeObj = liveTimeObj
        if(props._sessionID)
        {
            timeObj = convertMSToHMS( props._analyticsData.featureRunTime, true);
            timeObj.rawSeconds = timeObj.s;
            timeObj.rawMinutes = timeObj.m;
            timeObj.rawHours = timeObj.h
            timeObj.minutesStr = timeObj.m_str;
            timeObj.secondsStr = timeObj.s_str

        }
        const timeSecs = timeObj.rawHours * 3600 + timeObj.rawMinutes * 60 + timeObj.rawSeconds;
        const timePerc = timeSecs / (streamTargetTime / 1000) * 100;
    
        console.log('TIME OBJ',timeObj)

        return (
        <div className="stream-manager-time-row analytics-time-summary">
            <CirclePerc perc={timePerc < 100 ? timePerc : 100}>
                {IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.streamControlOptions)}
            </CirclePerc>
            <div className="timer-data stream-manager-timer-data analytics-time-copy">
                <p className="light-text">Stream Active Time</p>
                <h2 className="stream-manager-live-time">{`${timeObj.rawHours}h ${timeObj.minutesStr}m ${timeObj.secondsStr}s`}</h2>
                <p className="light-text small-text">Target: {`${targetTimeHms.h}h ${targetTimeHms.m_str}m ${targetTimeHms.s_str}s`}</p>
            </div>
        </div>)
    }
    //Channel Specific functions
    const getTotalUniqueUsers = (props) =>{
        console.log('UNIQUES', props._analyticsData)
        if(channelFilter && channelFilter.id != 'all')
        {
            for(let i=0; i< props._analyticsData.channels.length; i++)
            {
                if( props._analyticsData.channels[i].channel == channelFilter.id)
                {
                    return  props._analyticsData.channels[i].uniqueUsers
                }
            }
        }
        else return props._analyticsData.userList.length
    }
    const getTotalMessages = (props) =>{

        if(channelFilter && channelFilter.id != 'all')
        {
            for(let i=0; i< props._analyticsData.channels.length; i++)
            {
                if( props._analyticsData.channels[i].channel == channelFilter.id)
                {
                    return  props._analyticsData.channels[i].messages;
                }
            }
        }
        else return props._analyticsData.messages
    }

    const getTotalUniqueInteractionUsers = (props) =>{

        if(channelFilter && channelFilter.id != 'all')
        {
            for(let i=0; i< props._analyticsData.channels.length; i++)
            {
                if( props._analyticsData.channels[i].channel == channelFilter.id)
                {
                    return  props._analyticsData.channels[i].uniqueInteractionUsers;
                }
            }
        }
        else return props._analyticsData.uniqueInteractionUsers
    }
    const getTotalInteractions = (props) =>{

        if(channelFilter && channelFilter.id != 'all')
        {
            for(let i=0; i< props._analyticsData.channels.length; i++)
            {
                if( props._analyticsData.channels[i].channel == channelFilter.id)
                {
                    return  props._analyticsData.channels[i].interactions;
                }
            }
        }
        else return props._analyticsData.interactions
    }

    const getHashtagData = (props) =>{
       
 
        let combinedHashtagData = [];
            for(let i=0; i< props._analyticsData.channels.length; i++)
                {
                    console.log( props._analyticsData.channels.length)
                    if(channelFilter && channelFilter.id != 'all' && props._analyticsData.channels[i].channel == channelFilter.id)
                    {
                        return  props._analyticsData.channels[i].interactionCount;
                    }
                    else
                    {
                        props._analyticsData.channels[i].interactionCount.forEach(interaction => {
                            let isNewHashtag = true;
                            combinedHashtagData.forEach(hashtagData => {
                                console.log(hashtagData)
                                if(hashtagData.hashtag == interaction.hashtag)
                                {
                                    isNewHashtag = false;
                                    hashtagData.amount += interaction.amount;
                                }
                               
                            })
                            if(isNewHashtag)
                                {
                                    combinedHashtagData.push({hashtag: interaction.hashtag, amount:interaction.amount })
                                }
                        })
                        
                    }
                }
                return combinedHashtagData
    }

    //Interaction CHart Functions
    const changeTopInteractionStartTime = (timeDiff, barTimeVariation) => {
        setInteractionUsername('');
        setInteractionStartTimeOffset(timeDiff)
        setInteractionBarTimeVariation(barTimeVariation);
    }

    const updateTopInteractionStartTime = () => {
        if (interactionStartTimeOffset == -1) setTopInteractionStartTime(props._analyticsData.featureStartTime)
        else {
            let newTime = Date.now() - interactionStartTimeOffset;
            if (newTime < props._analyticsData.featureStartTime) newTime = props._analyticsData.featureStartTime;
            setTopInteractionStartTime(newTime);
        }
    }

    const getTimeString = (time) => {
        let timeObj = convertMSToHMS(time, true);
        return timeObj.h + ':' + timeObj.m_str + ':' + timeObj.s_str;
    }
    const getDurationString = (startTime, endTime) => {
        if (endTime == 0) endTime = getLiveEndTime() - props._analyticsData.featureStartTime;
        let time = endTime - startTime
        let timeObj = convertMSToHMS(time, true);
        return timeObj.h + 'h ' + timeObj.m_str + 'm ' + timeObj.s_str + 's';
    }

    const renderOverviewStat = (circleClassName, iconName, value, label) => {
        return (
            <div className="stream-manager-stat-row analytics-overview-stat-row" key={label}>
                <div className={`stream-manager-stat-circle ${circleClassName}`}>
                    {IconJsxer.GetIcon(IconJsxer.ICONS[iconName], IconJsxer.ICON_STYLES.analyticsKey)}
                </div>
                <div className="stream-manager-stat-copy">
                    <h3>{value}</h3>
                    <p>{label}</p>
                </div>
            </div>
        );
    }

    useEffect(
        () => {
            updateTopInteractionStartTime();
            updateTopChattersStartTime();
        }, [props._streamLiveTime, chartUsername]
    )

    useEffect(
        () => {
            setChartUsername('');
            setInteractionUsername('');
        },[channelFilter]

    )

    useEffect(
        () => {
            getFullAnalyticData();
        }, []
    )
    useEffect(
        () => {
            setPollingLiveAnlyticsData(prevState => {
                return prevState + 1
            })
        }, [props._streamLiveTime]
    )
    useEffect(
        () => {
            if (pollingLiveAnlyticsData == 60) {
                getFullAnalyticData();
            }
        }, [pollingLiveAnlyticsData]
    )
    //console.log('Analytics Data: ', props._analyticsData);

    return (
        <div className="ms-an-full-scroll-area">
            <div className="underlined-panel-heading">
                <h4>Stream Analytics Overview</h4>
                <div className="grow"></div>
            </div>

            {(!props._analyticsData || !props._analyticsData.botsFired) &&
                <div>Collecting data...</div>
            }

            {props._analyticsData && props._analyticsData.botsFired &&
                <>
                    <div className="stream-manager-section-box analytics-overview-chart-box">
                        <div className="underlined-panel-heading stream-manager-analytics-heading">
                            <h4>Viewer Analytics</h4>
                            <div className="grow"></div>
                            <div className="ana-data-holder viewer-counts analytics-viewer-stats-row">
                                {!props._sessionID &&
                                    <div className="fl-column compact">
                                        <p className="light-text">Current Viewers</p>
                                        <h4>{props._analyticsData.viewers.toLocaleString()}</h4>
                                    </div>
                                }
                                <div className="fl-column compact">
                                    <p className="light-text">Peak Viewers</p>
                                    <div className="fl-row compact">
                                        <h4>{props._analyticsData.peakViewers.toLocaleString()}</h4>
                                        <p className="light-text small-text align-bottom">({GetPeakViewerTime(props._analyticsData)})</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="stream-manager-analytics-chart analytics-chart-shell">
                            <ResponsiveContainer width="100%" height={240}>
                                <LineChart
                                    data={ViewerCountChartData(props._analyticsData)}
                                    isAnimationActive={false}
                                    margin={{ top: 5, right: 12, left: -24, bottom: 5 }}
                                >
                                    <CartesianGrid stroke="var(--mid-grey-2)" strokeOpacity={0.28} />
                                    <XAxis dataKey="time" {...CHART_AXIS_STYLE} />
                                    <YAxis {...CHART_AXIS_STYLE} />
                                    <Tooltip {...CHART_TOOLTIP_PROPS} />
                                    <Legend />
                                    <Line type="monotone" dataKey="ALL" stroke="#9146FF" strokeWidth={3} activeDot={{ r: 8 }} dot={{fill:"#9146FF", stroke:"#FFFFFF", strokeWidth: 2, r: 6, strokeDasharray: '' }} />
                                    {props._analyticsData.transcript && props._analyticsData.channels.map(
                                        (val, i) => {
                                            if(val.channel !== undefined)
                                            {
                                                return (
                                                    <Line key={`viewer_line_${val.channel}_${i}`} type="monotone" dataKey={val.channel.toUpperCase()} stroke={CHANNEL_COLOURS[i%8]} strokeWidth={1} strokeDasharray='5 5' activeDot={{ r: 8 }} dot={{ strokeWidth: 1, r: 4, strokeDasharray: '' }} />
                                                )
                                            }
                                            return null;
                                        }
                                    )}
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>

                    <div className="analytics-overview-grid">
                        <div className="stream-manager-section-box analytics-key-stats-box">
                            <div className="underlined-panel-heading">
                                <h4>Key Stats</h4>
                                <div className="grow"></div>
                            </div>

                            {!props._sessionID &&
                                <div className="analytics-meta-list">
                                    <div className="analytics-meta-item">
                                        <p className="light-text">Stream Title</p>
                                        <h5>{props._analyticsData.streamTitle}</h5>
                                    </div>
                                    <div className="analytics-meta-item">
                                        <p className="light-text">Game Name</p>
                                        <h5>{props._analyticsData.gameName}</h5>
                                    </div>
                                </div>
                            }

                            <div className="stream-manager-stats analytics-key-stats-grid">
                                {renderOverviewStat('stream-manager-stat-circle--engagement', 'bullhorn', CalculateEngagementTime(props._analyticsData), 'Feature Engagement')}
                                {renderOverviewStat('an-light-yellow-bg', 'hashtag', props._analyticsData.interactions ? props._analyticsData.interactions.toLocaleString() : 0, 'Total Interactions')}
                                {renderOverviewStat('an-light-purple-bg', 'multiUsers', props._analyticsData.userList ? props._analyticsData.userList.length.toLocaleString() : 0, 'Unique Users')}
                                {renderOverviewStat('analytics-stat-circle--features', 'star', GetFeaturesRunCount(props._analyticsData).toLocaleString(), 'Features Ran')}
                                {renderOverviewStat('analytics-stat-circle--bots', 'paperPlane', CalculateBotsTriggered(props._analyticsData).toLocaleString(), 'Bot Posts')}
                                {renderOverviewStat('analytics-stat-circle--disruptors', 'circle', GetDisruptorsRunCount(props._analyticsData).toLocaleString(), 'Disruptors Started')}
                            </div>
                        </div>

                        <div className="stream-manager-section-box analytics-general-stats-box">
                            <div className="underlined-panel-heading">
                                <h4>General Stream Stats</h4>
                                <div className="grow"></div>
                            </div>

                            {historicalTimeBar()}

                            <div className="ana-data-holder fl-column standard-text-color analytics-general-stats-list">
                                <div className="fl-row fill-width">
                                    <p>Start Time</p>
                                    <div className="grow"></div>
                                    <p className="light-text">{props._analyticsData.userList ? getShortDateTimeString(props._analyticsData.featureStartTime) : '[Not Started]'}</p>
                                </div>
                                <div className="fl-row fill-width">
                                    <p>End Time</p>
                                    <div className="grow"></div>
                                    <p className="light-text">{props._analyticsData.userList && getFeatureEndTime() !== 0 ? getShortDateTimeString(getFeatureEndTime()) : '[Still Running]'}</p>
                                </div>
                                <div className="fl-row fill-width">
                                    <p>Unique Users</p>
                                    <div className="grow"></div>
                                    <p className="light-text">{props._analyticsData.userList ? <>{props._analyticsData.userList.length.toLocaleString()}</> : <>0</>}</p>
                                </div>
                                <div className="fl-row fill-width">
                                    <p>Total Run Time</p>
                                    <div className="grow"></div>
                                    <p className="light-text">{props._analyticsData.userList ? getDurationString(0, props._analyticsData.featureRunTime) : '[No data]'}</p>
                                </div>
                                <div className="fl-row fill-width">
                                    <p>Total Interactions Recorded</p>
                                    <div className="grow"></div>
                                    <p className="light-text">{props._analyticsData.interactions ? <>{props._analyticsData.interactions.toLocaleString()}</> : <>0</>}</p>
                                </div>
                                <div className="fl-row fill-width">
                                    <p>Avg Interactions Per 10s</p>
                                    <div className="grow"></div>
                                    <p className="light-text">{props._analyticsData.interactions ? <>{(props._analyticsData.interactions / (props._analyticsData.featureRunTime / 10000)).toLocaleString()}</> : <>0</>}</p>
                                </div>
                                <div className="fl-row fill-width">
                                    <p>Top Users</p>
                                    <div className="grow"></div>
                                    <p className="light-text">{GetTopUsers(topInteractionStartTime, props._analyticsData).join(', ')}</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="analytics-section stream-manager-section-box analytics-section-boxed">
                        <div className="fl-row no-panel-shadow">

                            <div className="fl-column fl-equal fl-start">

                                <div className="underlined-panel-heading">
                                    <h4>Play Order - Timeline</h4>
                                    <div className="grow"></div>
                                </div>

                                <div className="an-tr-scroll-area">
                                    <div className="fl-column an-po-list">
                                        {props._analyticsData.featuresStarted.slice(0).reverse().map((entry, index) => {
                                            const displayData = getTimelineDisplay(entry);
                                            const campaignFeature = getCampaignFeatureForTimelineEntry(entry);
                                            const resolvedFeature = campaignFeature?.feature || null;
                                            const resolvedCategory = resolvedFeature?.iconCategory || resolvedFeature?.featureCategory || campaignFeature?.iconCategory || campaignFeature?.featureCategory || entry.iconCategory || entry.featureCategory || entry.colourCategory || entry.featureType;
                                            const resolvedCategoryClass = getIconCategoryClass(resolvedCategory);
                                            const resolvedCategoryColor = getIconCategoryColor(resolvedCategory);
                                            const resolvedIcon = resolvedFeature?.icon || campaignFeature?.icon;
                                            const resolvedVarKey = campaignFeature?.configKey || campaignFeature?.varKey || resolvedFeature?.varKey || entry.varKey;
                                            return (
                                                <div key={'po_' + index}>
                                                    <div className="fl-row">

                                                        <div className={`an-po-timeline-left${props._analyticsData.featuresStarted.length <= 1 ? ' only-po-item' : index === 0 ? ' first-po-item' : index === props._analyticsData.featuresStarted.length - 1 ? ' last-po-item' : ''}`}>
                                                            {index === props._analyticsData.featuresStarted.length - 1 &&
                                                                <img src={assets.AnPlayOrderLine} className="last-po-item-line" alt="" />
                                                            }
                                                            {index === 0 &&
                                                                <img src={assets.AnPlayOrderTopItem} alt="" />
                                                            }
                                                            {index > 0 &&
                                                                <img src={assets.AnPlayOrderItem} alt="" />
                                                            }
                                                            {index === props._analyticsData.featuresStarted.length - 1 &&
                                                                <div className="grow"></div>
                                                            }
                                                        </div>

                                                        <div className="fl-column compact an-po">
                                                            <div className="fl-row an-po-entry" style={{ color: resolvedCategoryColor }}>
                                                                <div className={`an-po-entry-icon category-icon-lozenge category-icon-bg--${resolvedCategoryClass}`}>
                                                                    {(resolvedIcon || resolvedVarKey) ? (
                                                                        <LottieIcon icon={resolvedIcon} varKey={resolvedVarKey} size={18} />
                                                                    ) : (
                                                                        IconJsxer.GetIcon(IconJsxer.ICONS[displayData.icon], IconJsxer.ICON_STYLES.standard)
                                                                    )}
                                                                </div>
                                                                <div>{entry.name}</div>
                                                            </div>
                                                            <div className="fl-row an-po-time">
                                                                <div>
                                                                    <span className="light-text">Time:</span> {getTimeString(entry.startTime * 1000)} - {entry.endTime == 0 && props._analyticsData.isLive ? <>NOW</> : <>{entry.endTime == 0 ? <> {getTimeString(getLiveEndTime()-props._analyticsData.featureStartTime)} </> : <>{getTimeString(entry.endTime * 1000)} </>
                                                                }</>}
                                                                </div>
                                                                <div>
                                                                    <span className="light-text">Duration:</span> {getDurationString(entry.startTime * 1000, entry.endTime * 1000)}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    {index < props._analyticsData.featuresStarted.length - 1 &&
                                                        <div className="fl-row">

                                                            <div className="an-po-timeline-left-divider">
                                                            </div>

                                                            <div className="fl-column grow">
                                                            </div>

                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>

                            </div>

                            <div className="fl-column fl-equal fl-start">

                                <div className="underlined-panel-heading">
                                    <h4>Stream Transcript</h4>
                                    <div className="grow"></div>
                                </div>

                                <div className="an-tr-scroll-area">
                                    <div className="fl-column">
                                        {(!props._analyticsData.transcript || props._analyticsData.transcript.length === 0) &&
                                            <div>No Activity Yet Reported</div>
                                        }
                                        {props._analyticsData.transcript && props._analyticsData.transcript.map(
                                            (val, i) => {
                                                return (
                                                    <StreamTranscriptItem
                                                        key={'transcript' + i}
                                                        itemData={{
                                                            type: val.transcriptType,
                                                            startTime: val.startTime,
                                                            endTime: val.endTime,
                                                            shortDescription: val.shortDescription,
                                                            longDescription: val.longDescription
                                                        }}
                                                        _showTooltip={props._showTooltip}
                                                        _hideTooltip={props._hideTooltip}
                                                    />
                                                )
                                            }
                                        )}
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>



                    <div className="analytics-section stream-manager-section-box analytics-section-boxed">
                    <div className="underlined-panel-heading">
                            <h4>Channel Analytics</h4>
                           {GetSessionDropdown(props)}
                            <div className="grow"></div>
                        </div>

                        <div className="analytics-sub-section">
                            <div className="fl-row">
                                <div className="grow"></div>
                                <div className="fl-row compact an-mxi-key light-text">
                                    <div className="circle-color-block an-light-blue-bg">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.comments, IconJsxer.ICON_STYLES.analyticsKey)}
                                    </div>
                                    <div>Messages</div>
                                </div>
                                <div className="fl-row compact an-mxi-key light-text">
                                    <div className="circle-color-block an-light-yellow-bg">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.hashtag, IconJsxer.ICON_STYLES.analyticsKey)}
                                    </div>
                                    <div>Interactions</div>
                                </div>
                                <div className="fl-row compact an-mxi-key light-text">
                                    <div className="circle-color-block an-light-purple-bg">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.multiUsers, IconJsxer.ICON_STYLES.analyticsKey)}
                                    </div>
                                    <div>Users</div>
                                </div>
                                <div className="fl-row compact light-text">
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.analyticsClock)}
                                    <FormDropDown
                                        className="an-mxi-drop"
                                        id="mxi_time"
                                        showLabel={false}
                                        showErrors={false}
                                        items={[
                                                {
                                                    id: '10_sec',
                                                    label: '10 sec',
                                                    value: MS_TIMES.SECS_10,
                                                },
                                                {
                                                    id: '30_sec',
                                                    label: '30 sec',
                                                    value: MS_TIMES.SECS_30,
                                                },
                                                {
                                                    id: '1_min',
                                                    label: '1 min',
                                                    value: MS_TIMES.MINS_1,
                                                },
                                                {
                                                    id: '5_min',
                                                    label: '5 min',
                                                    value: MS_TIMES.MINS_5,
                                                },
                                                {
                                                    id: '15_min',
                                                    label: '15 min',
                                                    value: MS_TIMES.MINS_15,
                                                },
                                            ]}
                                            selectFunc={(e, id, item) => { setSelectedMessagePerTime(item); setMessagePerTime(item.value) }}
                                            currentIndex={selectedMessagePerTime !== null ? selectedMessagePerTime.index : 0}
                                    />
                                </div>
                            </div>

                            <div className="analytics-chart-shell">
                                <ResponsiveContainer width="100%" height={300}>
                                    <AreaChart
                                        data={UserInteractionMessageChartData(props._analyticsData.featureStartTime, getLiveEndTime(), messagePerTime, props._analyticsData, null, channelFilter)}
                                        isAnimationActive={true}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: -20,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid stroke="var(--mid-grey-2)" strokeOpacity={0.28} />
                                        <XAxis dataKey="time" {...CHART_AXIS_STYLE} />
                                        <YAxis {...CHART_AXIS_STYLE} />
                                        <Tooltip {...CHART_TOOLTIP_PROPS} />
                                        <Legend />
                                        <Area type="monotone" isAnimationActive={true} fillOpacity={0.9} strokeWidth={2.15} name="Messages" dataKey="messages" fill={MESSAGE_CHART_FILL} stroke={MESSAGE_CHART_STROKE} />
                                        <Area type="monotone" isAnimationActive={true} fillOpacity={0.8} strokeWidth={1.85} name="Interactions" dataKey="interactions" fill={INTERACTION_CHART_FILL} stroke={INTERACTION_CHART_STROKE} />
                                        <Area type="monotone" isAnimationActive={true} fillOpacity={0.7} strokeWidth={1.75} name="New Chat Users" dataKey="uniqueMessageUsers" fill={USERS_CHART_FILL} stroke={USERS_CHART_STROKE} activeDot={{ r: 4, stroke: USERS_CHART_STROKE, strokeWidth: 2, fill: USERS_CHART_FILL }} />
                                    </AreaChart>
                                </ResponsiveContainer>
                            </div>

                        </div>


                        <div className="fl-row">

                            <div className="fl-column fl-equal fl-start">

                                <div className="fl-column analytics-sub-section">
                                    <h5 className="light-text">Messages:</h5>

                                    <div className="fl-row">

                                        <div>
                                            <PieChart width={200} height={100}>
                                                <Pie
                                                    dataKey="amt"
                                                    nameKey="labelName"
                                                    startAngle={180}
                                                    endAngle={0}
                                                    data={ChattersChartData(getTotalMessages(props), getTotalUniqueUsers(props))}
                                                    cx="50%"
                                                    cy="100%"
                                                    outerRadius={80}
                                                    innerRadius={55}
                                                    fill="#8884d8"
                                                    isAnimationActive={true}
                                                    stroke={PIE_SLICE_STROKE}
                                                    strokeWidth={PIE_SLICE_STROKE_WIDTH}

                                                >
                                                    {ChattersChartData(getTotalMessages(props), getTotalUniqueUsers(props)).map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                    ))}
                                                </Pie>
                                            </PieChart>
                                        </div>

                                        <div className="grow"></div>

                                        <div className="fl-column fl-equal an-pie-key">
                                            <div className="circle-color-block an-light-purple-bg">
                                                {IconJsxer.GetIcon(IconJsxer.ICONS.multiUsers, IconJsxer.ICON_STYLES.analyticsKey)}
                                            </div>
                                            <div>
                                                <h5>{props._analyticsData.userList ? <>{getTotalUniqueUsers(props).toLocaleString()}</> : <>0</>}</h5>
                                                <div className="light-text">Unique<br />Users</div>
                                            </div>
                                        </div>

                                        <div className="fl-column fl-equal an-pie-key">
                                            <div className="circle-color-block an-light-blue-bg">
                                                {IconJsxer.GetIcon(IconJsxer.ICONS.comments, IconJsxer.ICON_STYLES.analyticsKey)}
                                            </div>
                                            <div>
                                                <h5>{props._analyticsData.userList ? <>{getTotalMessages(props).toLocaleString()}</> : <>0</>}</h5>
                                                <div className="light-text">Total<br />Messages</div>
                                            </div>
                                        </div>

                                        <div className="fl-column fl-equal an-pie-key">
                                            <div className="circle-color-block an-parity-grey-bg">
                                                {IconJsxer.GetIcon(IconJsxer.ICONS.projectPlan, IconJsxer.ICON_STYLES.analyticsKey)}
                                            </div>
                                            <div>
                                                <h5>{props._analyticsData.userList ? <>{CalculateAvgMsgPerUser(getTotalMessages(props), getTotalUniqueUsers(props)).toLocaleString()}</> : <>0</>}</h5>
                                                <div className="light-text">Average<br />Messages</div>
                                            </div>
                                        </div>

                                        <div className="grow"></div>

                                    </div>
                                </div>

                                <h5 className="light-text">Interactions:</h5>

                                <div className="fl-row">

                                    <div>
                                        <PieChart width={200} height={100}>
                                            <Pie
                                                dataKey="amt"
                                                nameKey="labelName"
                                                startAngle={180}
                                                endAngle={0}
                                                data={InteractionChartData(getTotalInteractions(props), getTotalUniqueInteractionUsers(props))}
                                                cx="50%"
                                                cy="100%"
                                                outerRadius={80}
                                                innerRadius={55}
                                                fill="#8884d8"
                                                isAnimationActive={true}
                                                stroke={PIE_SLICE_STROKE}
                                                strokeWidth={PIE_SLICE_STROKE_WIDTH}

                                            >
                                                {InteractionChartData(getTotalInteractions(props), getTotalUniqueInteractionUsers(props)).map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS1[index % COLORS1.length]} />
                                                ))}
                                            </Pie>
                                        </PieChart>
                                    </div>

                                    <div className="grow"></div>

                                    <div className="fl-column fl-equal an-pie-key">
                                        <div className="circle-color-block an-light-purple-bg">
                                            {IconJsxer.GetIcon(IconJsxer.ICONS.multiUsers, IconJsxer.ICON_STYLES.analyticsKey)}
                                        </div>
                                        <div>
                                            <h5>{props._analyticsData.uniqueInteractionUsers ? <>{getTotalUniqueInteractionUsers(props).toLocaleString()}</> : <>0</>}</h5>
                                            <div className="light-text">Unique<br />Users</div>
                                        </div>
                                    </div>

                                    <div className="fl-column fl-equal an-pie-key">
                                        <div className="circle-color-block an-light-yellow-bg">
                                            {IconJsxer.GetIcon(IconJsxer.ICONS.hashtag, IconJsxer.ICON_STYLES.analyticsKey)}
                                        </div>
                                        <div>
                                            <h5>{props._analyticsData.interactions ? <>{getTotalInteractions(props).toLocaleString()}</> : <>0</>}</h5>
                                            <div className="light-text">Total<br />Interactions</div>
                                        </div>
                                    </div>

                                    <div className="fl-column fl-equal an-pie-key">
                                        <div className="circle-color-block an-parity-grey-bg">
                                            {IconJsxer.GetIcon(IconJsxer.ICONS.projectPlan, IconJsxer.ICON_STYLES.analyticsKey)}
                                        </div>
                                        <div>
                                            <h5>{props._analyticsData.interactions ? <>{CalculateAvgInteractionPerUser(getTotalInteractions(props), getTotalUniqueInteractionUsers(props)).toLocaleString()}</> : <>0</>}</h5>
                                            <div className="light-text">Average<br />Interactions</div>
                                        </div>
                                    </div>

                                    <div className="grow"></div>


                                </div>


                            </div>

                            <div className="fl-column fl-equal fl-start">
                                
                                <h5 className="light-text">Hashtags:</h5>

                                <div className="analytics-chart-shell">
                                    <ResponsiveContainer width="100%" height={300}>
                                        <BarChart
                                            data={CalculateHashtagChartData(getHashtagData(props))}
                                            layout="vertical"
                                            isAnimationActive={true}
                                            margin={{
                                                top: 5,
                                                right: 30,
                                                left: -20,
                                                bottom: 5,
                                            }}
                                        >
                                            <CartesianGrid stroke="var(--mid-grey-2)" strokeOpacity={0.28} />
                                            <XAxis type="number" dataKey="amount" tickCount={6} allowDecimals={false} {...CHART_AXIS_STYLE} />
                                            <YAxis type="category" dataKey="hashtag" tickCount={4} {...CHART_AXIS_STYLE} />
                                            <Tooltip {...CHART_TOOLTIP_PROPS} />
                                            <Bar barSize={20} name="Interactions" dataKey="amount" fill="#FFD581" />

                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>

                            </div>

                        </div>

                    </div>


                    <div className="analytics-section stream-manager-section-box analytics-section-boxed">

                        <div className="underlined-panel-heading">


                            <div className="fl-row grow">


                                <div className="fl-row fl-equal">



                                    <h4>Top Users</h4>
                                    <div className="grow"></div>

                                    <FormDropDown
                                        className="an-tutype-drop"
                                        id="tu_type"
                                        showLabel={false}
                                        showErrors={false}
                                        items={[
                                            {
                                                id: 'messages',
                                                label: 'Messages',
                                                value: 'messages',
                                            },
                                            {
                                                id: 'interactions',
                                                label: 'Interactions',
                                                value: 'interactions',
                                            },

                                        ]}
                                        selectFunc={(e, id, item) => { setSelectedTopUsersType(item); setTopUserChart(item.value) }}
                                        currentIndex={selectedTopUsersType !== null ? selectedTopUsersType.index : 0}
                                    />



                                </div>


                                <div className="fl-row fl-equal">
                                    <div className="grow"></div>

                                    <div className="fl-row compact light-text">
                                        {IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.analyticsClock)}
                                      
                                        {!props._sessionID && 
                                        
                                        <FormDropDown
                                            className="an-tutype-drop"
                                            id="tu_time"
                                            showLabel={false}
                                            showErrors={false}
                                            items={[
                                                {
                                                    id: 'stream_all',
                                                    label: 'Whole Stream',
                                                    value: -1,
                                                    barTimeVariation: MS_TIMES.MINS_5,
                                                },
                                                {
                                                    id: 'last_hour',
                                                    label: 'Last Hour',
                                                    value: MS_TIMES.MINS_5,
                                                    barTimeVariation: MS_TIMES.SECS_10,
                                                },
                                                {
                                                    id: 'last_30_mins',
                                                    label: 'Last 30 Mins',
                                                    value: MS_TIMES.MINS_15,
                                                    barTimeVariation: MS_TIMES.SECS_30,
                                                },
                                                {
                                                    id: 'last_15_mins',
                                                    label: 'Last 15 Mins',
                                                    value: MS_TIMES.MINS_30,
                                                    barTimeVariation: MS_TIMES.MINS_1,
                                                },
                                                {
                                                    id: 'last_5_mins',
                                                    label: 'Last 5 Mins',
                                                    value: MS_TIMES.HOURS_1,
                                                    barTimeVariation: MS_TIMES.MINS_1,
                                                },
                                            ]}
                                            selectFunc={(e, id, item) => { setSelectedTopUsersTime(item); changeTopChattersStartTime(item.value, item.barTimeVariation); changeTopInteractionStartTime(item.value, item.barTimeVariation) }}
                                            currentIndex={selectedTopUsersTime !== null ? selectedTopUsersTime.index : 0}
                                        />}
                                    </div>





                                </div>
                            </div>


                        </div>


                        <div className="fl-row">

                            <div className="fl-column fl-equal fl-start">
                                <div className="an-tu-scroll-area">
                                    {topUserChart == 'messages' && CalculateTopChatters(topChattersStartTime, props._analyticsData, channelFilter).map(function (data, index) {
                                        if (index == 0 && chartUsername == '') setChartUsername(data.username)
                                        return (
                                            <div className={`an-user-list-item ${index % 2 === 0 ? 'an-user-light' : 'an-user-dark'}`} onClick={(e) => { setChartUsername(data.username) }} key={'un' + index}>
                                                <div className="black-text">{index < 9 ? '0' : ''}{index + 1}.</div>
                                                <div  className="black-text">{'['+data.channelName.toUpperCase()+'] '} </div>
                                                <div>{data.username}</div>
                                                <div className="grow"></div>
                                                <div className="black-text">{data.timedAmount} Messages</div>
                                            </div>
                                        )
                                    })}

                                    {topUserChart == 'interactions' && CalculateTopInteractionUsers(topInteractionStartTime, props._analyticsData, channelFilter).map(function (data, index) {
                                        if (index == 0 && interactionUsername == '') setInteractionUsername(data.username)
                                        return (
                                            <div className={`an-user-list-item ${index % 2 === 0 ? 'an-user-light' : 'an-user-dark'}`} onClick={(e) => { setInteractionUsername(data.username) }} key={'un' + index}>
                                                <div className="black-text">{index < 9 ? '0' : ''}{index + 1}.</div>
                                                <div  className="black-text">{'['+data.channelName.toUpperCase()+'] '} </div>
                                                <div>{data.username}</div>
                                                <div className="grow"></div>
                                                <div className="black-text">{data.timedAmount} Interactions</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>

                            <div className="fl-column fl-equal fl-start">

                                <h5 className="light-text">{topUserChart == 'messages' ? chartUsername : interactionUsername} Message History</h5>

                                    <div className="analytics-chart-shell">
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart
                                                data={UserInteractionMessageChartData(topChattersStartTime, getLiveEndTime(), chattersBarTimeVariation, props._analyticsData, topUserChart == 'messages' ? chartUsername : interactionUsername)}
                                                isAnimationActive={false}
                                                margin={{
                                                    top: 5,
                                                    right: 30,
                                                    left: -20,
                                                    bottom: 5,
                                                }}
                                            >
                                                <CartesianGrid stroke="var(--mid-grey-2)" strokeOpacity={0.28} />
                                                <XAxis dataKey="time" {...CHART_AXIS_STYLE} />
                                                <YAxis tickCount={6} allowDecimals={false} {...CHART_AXIS_STYLE} />
                                                <Tooltip {...CHART_TOOLTIP_PROPS} />
                                                <Legend />
                                                <Bar barSize={20} name="Interactions" dataKey="interactions" stackId="a" fill="#FFD581" />
                                                <Bar barSize={20} name="Messages" dataKey="messages" stackId="a" fill={MESSAGE_CHART_FILL} />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>

                            </div>

                        </div>



                    </div>




                </>
            }
        </div>
    )
}

export default TabAnalytics
